import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/quotations/quotations.module').then( m => m.QuotationsPageModule), 
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('./folder/folder.module').then( m => m.FolderPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then( m => m.AuthPageModule)
  }, 
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardPageModule),
    canActivate: [AuthGuard]
  },   {
    path: 'customers',
    loadChildren: () => import('./pages/customers/customers.module').then( m => m.CustomersPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'metamaster',
    loadChildren: () => import('./pages/metamaster/metamaster.module').then( m => m.MetamasterPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'branch',
    loadChildren: () => import('./pages/branch/branch.module').then( m => m.BranchPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'leads',
    loadChildren: () => import('./pages/leads/leads.module').then( m => m.LeadsPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'cities',
    loadChildren: () => import('./pages/cities/cities.module').then( m => m.CitiesPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'citiestwo',
    loadChildren: () => import('./pages/citiestwo/citiestwo.module').then( m => m.CitiestwoPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'bankstatement',
    loadChildren: () => import('./pages/bankstatement/bankstatement.module').then( m => m.BankstatementPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'transactions',
    loadChildren: () => import('./pages/transactions/transactions.module').then( m => m.TransactionsPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'license',
    loadChildren: () => import('./pages/license/license.module').then( m => m.LicensePageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'report',
    loadChildren: () => import('./pages/report/report.module').then( m => m.ReportPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'einvoicect',
    loadChildren: () => import('./pages/einvoicect/einvoicect.module').then( m => m.EinvoicectPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'refund-transactions',
    loadChildren: () => import('./pages/refund-transactions/refund-transactions.module').then( m => m.RefundTransactionsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'creditnote',
    loadChildren: () => import('./pages/creditnote/creditnote.module').then( m => m.CreditnotePageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'users',
    loadChildren: () => import('./pages/users/users.module').then( m => m.UsersPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'roles',
    loadChildren: () => import('./pages/roles/roles.module').then( m => m.RolesPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'quotation',
    loadChildren: () => import('./pages/quotations/quotations.module').then( m => m.QuotationsPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },  
  {
    path: 'noc-foc',
    loadChildren: () => import('./pages/noc-foc/noc-foc.module').then( m => m.NocFocPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'tracking',
    loadChildren: () => import('./pages/tracking/tracking.module').then( m => m.TrackingPageModule),
    canActivate: [AuthGuard] //AuthGuard
  },
  {
    path: 'requests',
    loadChildren: () => import('./pages/request/request-list/request-list.module').then( m => m.RequestListPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'requests/:request-type',
    loadChildren: () => import('./pages/request/request-list/request-list.module').then( m => m.RequestListPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'request-addedit',
    loadChildren: () => import('./pages/request/request-addedit/request-addedit.module').then( m => m.RequestAddeditPageModule),
    canActivate: [AuthGuard]
  },
   {
    path: 'cart-discount-request',
    loadChildren: () => import('./pages/request/cart-discount-request/cart-discount-request.module').then( m => m.CartDiscountRequestPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'one-window-pi',
    loadChildren: () => import('./pages/one-window-pi/one-window-pi.module').then( m => m.OneWindowPiPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'legal-notice',
    loadChildren: () => import('./pages/legal-notice/legal-notice.module').then(m => m.LegalNoticePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'advocate-master',
    loadChildren: () => import('./pages/advocate-master/advocate-master.module').then(m => m.AdvocateMasterPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'region-master',
    loadChildren: () => import('./pages/region-master/region-master.module').then(m => m.RegionMasterPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'venue-master',
    loadChildren: () => import('./pages/venue-master/venue-master.module').then(m => m.VenueMasterPageModule),
    canActivate: [AuthGuard]
  }
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
